import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Svg from 'elements/Svg/Svg';

import './Visibleleadtime.scss';

export default class VisibleLeadTime extends PureComponent {
    static propTypes = {
        icon: PropTypes.string,
        leadTimePrefix: PropTypes.string,
        value: PropTypes.string,
    };

    renderIcon() {
        const iconClass = this.props.showContactUs
                            ? "visible-lead-time__contact-us-icon"
                            : "visible-lead-time__icon";

        return <Svg name={this.props.icon} overrideClassName={true} className={iconClass} />;
    }

    render() {
        const { leadTimePrefix, value } = this.props;

        return (
            <div className="visible-lead-time__panel">
                <p className="visible-lead-time__prefix">{leadTimePrefix}</p>
                <div className="visible-lead-time__details">
                    {this.renderIcon()}
                    <p className="visible-lead-time__value">
                        {value}
                    </p>
                </div>
            </div>
        );
    }
}
